import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 10px;

  ul {
    text-align: left;
    background: #fff8e1;
    border-left: 4px solid #f5b700;
    padding: 12px 20px 12px 35px;
    margin: 15px 0;
    border-radius: 4px;
    list-style-type: disc;
  }

  li {
    color: #444;
    font-size: 14px;
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  p.question {
    font-weight: 600;
    color: #272727;
    margin-top: 15px;
  }
`;
